module.exports = __webpack_public_path__ + "static/media/7.52d2378e.jpg";